function getRecipients(o) {
  // TODO: eventually, every order should have an 'info.recipients' property. Use this function as a transition. Note
  // that this does NOT handle multi-send recipients.
  if (!o)
    return [];
  if (o.info.recipients)
    return o.info.recipients;
  const key = o.info.delivery_type == 'EMAIL' ? 'email' : 'phone';
  const recipient = { to: o.info.to || null };
  recipient[key] = o.info['to_' + key];
  if (!recipient[key])
    return [];
  return [ recipient ];
}

export default getRecipients;
